import Radium from 'radium';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { semanticColors, greyScaleColors } from '../../../../Globals/styles';
import {
  attemptAddTask,
  attemptToggleTaskIsChecked,
  attemptGetWorkplaceTasks,
  attemptDeleteTask
} from './actions';
import Waves from 'node-waves'

class Tasks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      isDeleteMode: false
    }
  }
  componentWillMount = () => {
    this.props.dispatch(attemptGetWorkplaceTasks(this.props.workplaceId));
  };
  componentDidMount = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  componentDidUpdate = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };

  componentWillReceiveProps = (nextProps) => {
    // eslint-disable-next-line
    if (this.props.tasks.length == 1 && nextProps.tasks.length == 0) {
      this.setState({
        isDeleteMode: false
      })
    }
  };

  onInputFieldChange = (evt) => {
    this.setState({
      inputValue: evt.target.value
    })
  };
  onSave = () => {
    this.props.dispatch(attemptAddTask(this.props.workplaceId, this.state.inputValue))
    this.setState({
      inputValue: '',
      isDeleteMode: false
    })
  };

  onDeleteMode = () => {
    this.setState({
      isDeleteMode: !this.state.isDeleteMode
    })
  };



  render() {
    const { tasks, workplaceId, dispatch } = this.props;
    let taskNodes = tasks.map((task, index) => {
      return (
        <div key={task.id} style={styles.taskContainer}>
          {this.state.isDeleteMode ?
            <i className="fa fa-trash-o waves-icon"
              style={styles.deleteTaskIcon}
              onClick={() => { dispatch(attemptDeleteTask(workplaceId, task.id, index)) }}
            />
            :
            !task.isChecked ?
              <div
                style={[styles.checkContainer]}
                className="col-xs-2 waves-icon"
                onClick={() => dispatch(attemptToggleTaskIsChecked(workplaceId, task.id, index, !task.isChecked))}>
                <i className="fa fa-square-o" aria-hidden="true"></i>
              </div>
              :
              <div
                style={[styles.checkContainer]}
                className="col-xs-2 waves-icon"
                onClick={() => dispatch(attemptToggleTaskIsChecked(workplaceId, task.id, index, !task.isChecked))}>
                <i className="fa fa-check-square-o" aria-hidden="true"></i>
              </div>
          }
          <span style={[task.isChecked && styles.taskTextIsChecked]}>{task.text}</span>
        </div>
      )
    })
    return (
      <div>
        <div style={this.state.isDeleteMode ? styles.firstOverlay : null}></div>
        <div style={styles.mainContainer}>
          {taskNodes.length ?
            <div className="waves-btn"
              style={styles.iconContainer}
              onClick={this.onDeleteMode}>
              <i className="fa fa-pencil"
                style={[styles.pencil, this.state.isDeleteMode ? styles.pencilActive : null]}
              />
              <div style={styles.iconLabel}>Rediger</div>
            </div> : null
          }
          {taskNodes}
          <input
            style={styles.input}
            placeholder="Ny opgave..."
            onChange={this.onInputFieldChange}
            value={this.state.inputValue}
          />
          <button
            className={"btn btn-primary waves-btn"}
            disabled={!this.state.inputValue}
            onClick={this.onSave}
            style={styles.saveButton}
          >Opret</button>
        </div>
      </div>
    );
  }
}
var styles = {
  mainContainer: {
    zIndex: '50',
    position: 'relative'
  },
  input: {
    height: '35px',
    width: '70%',
    border: 'none',
    paddingLeft: '5px',
    borderRadius: '2px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset'
  },
  saveButton: {
    float: 'right',
    zIndex: '0',
    width: '28%'
  },
  taskContainer: {
    position: 'relative',
    width: '100%',
    paddingLeft: '40px',
    height: '35px',
    lineHeight: '35px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  checkContainer: {
    position: 'absolute',
    left: '0px',
    fontSize: '20px',
    lineHeight: '35px',
    height: '35px',
    width: '35px',
    top: '0',
    textAlign: 'center',
    paddingLeft: '10px',
    color: semanticColors.text
  },
  taskTextIsChecked: {
    textDecoration: 'line-through',
    color: greyScaleColors.greyLight
  },
  deleteTaskIcon: {
    fontSize: '20px',
    float: 'left',
    color: semanticColors.danger,
    cursor: 'pointer',
    lineHeight: '35px',
    height: '35px',
    width: '35px',
    textAlign: 'center',
    position: 'absolute',
    left: '0px',
    top: '0px'
  },
  iconContainer: {
    fontSize: '22px',
    height: '45px',
    width: '50px',
    padding: '0px',
    textAlign: 'center',
    position: 'absolute',
    top: '-30px',
    right: '12px',
    zIndex: '2',
    lineHeight: '20px'
  },
  pencil: {
    display: 'inline-block',
    width: '30px',
    height: '30px',
    lineHeight: '30px',
    cursor: 'pointer'
  },
  pencilActive: {
    color: semanticColors.info
  },
  iconLabel: {
    fontSize: '12px',
    fontWeight: '600',
    marginTop: '-3px'
  },
  firstOverlay: {
    position: 'fixed',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
    zIndex: '50',
    backgroundColor: semanticColors.default,
    opacity: '0.5'
  }
}

const selectProps = state => {
  return {
    ...state.workplaceTasksReducer
  };
}
Tasks.propTypes = {
  dispatch: PropTypes.func.isRequired,
  tasks: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    isChecked: PropTypes.bool.isRequired
  })),
  workplaceId: PropTypes.string.isRequired
};
export default connect(selectProps)(Radium(Tasks));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Overview/Tasks/index.jsx